<template>
  <div class="app-container">

    <div class="box">

      <div class="filter-container">
        <el-input placeholder="订单编号" v-model="pagination.username" style="width: 200px;" class="filter-item"></el-input>
        <el-button @click="getorderslist()" class="dalfBut">查询</el-button>
      </div>

      <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
        <el-table-column type="index" align="center" label="序号"></el-table-column>
        <el-table-column prop="orderId" label="订单号"  align="center"></el-table-column>
        <el-table-column prop="userPhone" label="购买人" align="center"></el-table-column>
        <el-table-column prop="price" label="价格" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" align="center"></el-table-column>
        <el-table-column prop="createTime" label="订单时间" align="center"></el-table-column>
        <el-table-column prop="description" label="描述" align="center"></el-table-column>
        <el-table-column prop="istrue" label="支付完成" align="center"></el-table-column>

        <!--        <el-table-column label="更改激活次数" align="center" width="80px">-->

        <!--          <template slot-scope="scope">-->

        <!--            <el-button type="primary" size="mini" @click="handleUpdateactivetime(scope.row)">编辑</el-button>-->

        <!--          </template>-->

        <!--        </el-table-column>-->


      </el-table>

      <!--分页组件-->
      <div class="pagination-container">

        <el-pagination
            class="pagiantion"

            @current-change="handleCurrentChange"

            :current-page="pagination.currentPage"

            :page-size="pagination.pageSize"

            layout="total, prev, pager, next, jumper"

            :total="pagination.total">

        </el-pagination>

      </div>

      <!-- 新增标签弹层 -->


    </div>

  </div>


</template>

<script>
import axios from "@/axios";

export default {
  data() {
    return {
      dataList: [],//当前页要展示的列表数据
      pagination: {//分页相关模型数据
        currentPage: 1,//当前页码
        pageSize:10,//每页显示的记录数
        total:0,//总记录数
        username:""
      },
    }
  },
  created() {
    this.getorderslist()

  },

  methods: {

    // selectbyusername(){
    //   axios({
    //     method:"post",
    //     url:"/app/user/list",
    //     data: this.selectbyusername
    //   }).then(res=>{
    //     this.pagination.pageSize = res.data.data[0].size;
    //     this.pagination.currentPage = res.data.data[0].current;
    //     this.pagination.total = res.data.data[0].total;
    //     this.dataList = res.data.data[0].records
    //     console.log("----------------------------------------------")
    //     console.log(res.data.data[0].records)
    //   })
    // },

    getorderslist() {
      axios({
        method: "post",
        url: "/sys/orders/page",
        data: {
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          username: this.pagination.username
        }
      }).then(res => {
        this.pagination.pageSize = res.data.data.size;
        this.pagination.currentPage = res.data.data.current;
        this.pagination.total = res.data.data.total;
        this.dataList = res.data.data.records
        //console.log(this.dataList.username.length);
      })
    },
    //切换页码
    handleCurrentChange(currentPage) {
      //修改页码值为当前选中的页码值
      this.pagination.currentPage = currentPage;
      //执行查询
      this.getorderslist();
    },

    // // 删除
    // handleDelete(row) {
    //   // console.log(row);
    //   this.$confirm("此操作永久删除当前信息，是否继续？","提示",{type:"info"}).then(()=>{
    //     axios.delete("/app/user/delete/"+row.id).then((res)=>{
    //         this.$message.success("删除成功");
    //     }).finally(()=>{
    //       //2.重新加载数据
    //       this.getuserlist();
    //     });
    //   }).catch(()=>{
    //     this.$message.info("取消操作");
    //   });
    // },
  }
}
</script>

<style scoped>

.app-container{

  background: #fff;

  margin: 15px 30px 15px 15px;

}

.box {

  position: relative;

  border-radius: 3px;

  background: #ffffff;

  border-top: 3px solid #3c8dbc;

  padding: 10px;

  margin-bottom: 20px;

  width: 100%;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

}

.filter-container{

  float: left;
  padding:10px 0 15px 0;


}
.pagiantion{

  text-align: right;

  padding: 15px;

}

</style>
